<template>
  <b-card title="Doktor Takvimi">
    <b-table-simple
      hover
      small
      caption-top
      responsive
      bordered
    >
      <b-thead>
        <b-tr>
          <b-th
            width="500"
          >
            DR. Abdullah Doğan
          </b-th>
          <b-th
            width="250"
            class="text-center"
          >
            Merkez Şube
          </b-th>
          <b-th
            width="250"
            class="text-center"
          >
            Makyağsan
          </b-th>
          <b-th
            width="250"
            class="text-center"
          >
            Hyundai
          </b-th>
          <b-th
            width="250"
            class="text-center"
          >
            Özlüce
          </b-th>
          <b-th
            width="250"
            class="text-center"
          >
            Yüzüncü Yıl
          </b-th>
          <b-th
            width="250"
            class="text-center"
          >
            Bosch Car
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr>
          <b-td>Pazartesi</b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            15:30-16:30
          </b-td>
          <b-td class="text-center">
            16:30-17:30
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Salı</b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Çarşamba</b-td>
          <b-td class="text-center">
            10:00-13:00
          </b-td>
          <b-td class="text-center">
            09:00-10:00
          </b-td>
          <b-td class="text-center">
            15:00-17:30
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            13:30-14:30
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Perşembe</b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Cuma</b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
        </b-tr>
        <b-tr>
          <b-td>Cumartesi</b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
          <b-td class="text-center">
            -
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </b-card>
</template>

<script>
import {
  BCard, BTableSimple, BThead, BTbody, BTr, BTd, BTh,
} from 'bootstrap-vue'

export default {
  name: 'DoctorCalendar',
  components: {
    BCard,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTd,
    BTh,
  },
}
</script>

<style scoped>
</style>
